export enum ItemTypes {
  ELEMENT = "Element",
  COMPONENT = "Component",
  TREE_NODE = "TreeNode",
  ASSET = "Asset",
  TEMPLATE = "Template",
  FORMWIZARD = "FormWizard"
}
